export default __webpack_public_path__ + "static/media/step-three-3.1103cbf3.svg";